import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31097 16106"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:450.686}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970247332192">
        <path
          d="M16120 15070 8805 8675c-377-330-377-915 0-1243l7315-6395c321-282 123-812-305-812H9292c-349 0-687 127-949 357L507 7432c-376 328-376 914 0 1243l7836 6849c263 230 600 356 949 356h6523c428 0 626-529 305-810zM20439 524c339 338 339 886 0 1224-338 339-887 339-1225 0-338-338-338-886 0-1224 338-339 887-339 1225 0zM18133 2829c338 339 338 887 0 1225-338 339-887 339-1225 0-339-338-339-886 0-1225 338-339 887-339 1225 0z"
          className="fill stroke1"
          style={{
            strokeWidth: 450.686,
          }}
        />
        <path
          d="M15828 5134c338 339 338 888 0 1226-339 339-887 339-1225 0-339-338-339-886 0-1226 337-338 886-338 1225 0zM13521 7440c339 339 339 888 0 1226-338 338-886 338-1224 0-339-338-339-887 0-1226 338-338 886-338 1224 0zM20439 15583c339-338 339-887 0-1225-338-338-887-338-1225 0s-338 887 0 1225 887 338 1225 0zM18133 13277c338-338 338-886 0-1225-338-338-887-338-1225 0-339 339-339 887 0 1225 338 339 887 339 1225 0zM15828 10972c338-339 338-887 0-1225-339-338-887-338-1225 0-339 338-339 886 0 1225 337 338 886 338 1225 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 450.686,
          }}

        />
        <path
          d="M13521 8666c339-338 339-887 0-1226-338-338-886-338-1224 0-339 339-339 888 0 1226 338 338 886 338 1224 0zM25529 524c338 338 338 886 0 1224-339 339-887 339-1225 0-339-338-339-886 0-1224 338-339 886-339 1225 0zM23222 2829c339 339 339 887 0 1225-338 339-886 339-1224 0-339-338-339-886 0-1225 338-339 886-339 1224 0zM20917 5134c338 339 338 888 0 1226-338 339-887 339-1225 0-339-338-339-886 0-1226 338-338 887-338 1225 0zM18611 7440c339 339 339 888 0 1226-338 338-887 338-1225 0s-338-887 0-1226c338-338 887-338 1225 0zM25529 15583c338-338 338-887 0-1225-339-338-887-338-1225 0-339 338-339 887 0 1225 338 338 886 338 1225 0zM23222 13277c339-338 339-886 0-1225-338-338-886-338-1224 0-339 339-339 887 0 1225 338 339 886 339 1224 0zM20917 10972c338-339 338-887 0-1225s-887-338-1225 0c-339 338-339 886 0 1225 338 338 887 338 1225 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 450.686,
          }}

        />
        <path
          d="M18611 8666c339-338 339-887 0-1226-338-338-887-338-1225 0-338 339-338 888 0 1226s887 338 1225 0zM30618 524c339 338 339 886 0 1224-338 339-887 339-1225 0-338-338-338-886 0-1224 338-339 887-339 1225 0zM28313 2829c338 339 338 887 0 1225-339 339-887 339-1225 0-339-338-339-886 0-1225 338-339 886-339 1225 0zM26006 5134c339 339 339 888 0 1226-338 339-886 339-1225 0-338-338-338-886 0-1226 339-338 887-338 1225 0zM23701 7440c338 339 338 888 0 1226s-887 338-1225 0c-339-338-339-887 0-1226 338-338 887-338 1225 0zM30618 15583c339-338 339-887 0-1225-338-338-887-338-1225 0s-338 887 0 1225 887 338 1225 0zM28313 13277c338-338 338-886 0-1225-339-338-887-338-1225 0-339 339-339 887 0 1225 338 339 886 339 1225 0zM26006 10972c339-339 339-887 0-1225-338-338-886-338-1225 0-338 338-338 886 0 1225 339 338 887 338 1225 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 450.686,
          }}

        />
        <path
          d="M23701 8666c338-338 338-887 0-1226-338-338-887-338-1225 0-339 339-339 888 0 1226 338 338 887 338 1225 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 450.686,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
